// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n\n/* Mixins */\n@media (max-width: 768px) {\n.el-dialog {\n    width: 95% !important;\n    margin: 5vh auto 0 !important;\n}\n}", ""]);
// Exports
exports.locals = {
	"menuBg": "#0F4C81",
	"menuText": "#ffffff",
	"menuActiveText": "#0F4C81",
	"menuActiveBg": "#ffffff"
};
module.exports = exports;
